import { DataBindingMode, IVirtualPanelItem } from '@se/cp.common';
import { DataBinding } from '@se/se.platform.base';
import { CpEntityList, ICpEntity } from '../cp-configuration/view-model';
import { IMenuItem, ITabSelector, ParentNodeId, UniqueKey } from './types';

export const createUniqueKey = (
    virtualPanel: IVirtualPanelItem,
    parentId: ParentNodeId,
    entityId: string,
    selectedSourceItemId: string,
): string => {
    if (virtualPanel.virtualPanel.dataBindingMode === DataBindingMode.Single) {
        /*@NB non puo essere binding avanzato su mode Single*/
        return `${parentId}__${virtualPanel.virtualPanel.dataBinding.split('.').pop()}`;
    }

    const eid =
        virtualPanel.virtualPanel.dataBindingMode === DataBindingMode.PropertyExclusive
            ? selectedSourceItemId
            : entityId;
    return `${parentId}__${eid}`;
};

export const countVirtualChildByParentId = (parentId: string, setOfAddedVirtualPanelsIds: Set<UniqueKey>): number => Array.from(setOfAddedVirtualPanelsIds).filter(id => id.startsWith(parentId)).length;


export const filterVirtualPanelForAdvancedItem = (
    virtualPanel: IVirtualPanelItem,
    entity: ICpEntity,
    parentEntity: ICpEntity,
): boolean => {
    const id = new DataBinding(virtualPanel.virtualPanel.dataBinding).getFirstAdvancedItemId();
    if (!id || !(parentEntity instanceof CpEntityList)) return true;
    const bindingKey = parentEntity.advancedDataBindingKeysList[0];
    const selectedSourceItemId = entity.getNestedPropertyValue(`${bindingKey}.Id`) ?? null;
    return id === selectedSourceItemId;
};

export const getSelectedSourceItemId = (
    virtualPanel: IVirtualPanelItem,
    entity: ICpEntity,
    parentEntity: ICpEntity,
): string | null => {
    if (!(parentEntity instanceof CpEntityList)) return null;
    const bindingKey =
        parentEntity.advancedDataBindingKeysList[0] ??
        new DataBinding(virtualPanel.virtualPanel.dataBinding).propertyName;
    const selectedSourceItemId = entity.getNestedPropertyValue(`${bindingKey}.Id`);
    if (selectedSourceItemId) return String(selectedSourceItemId);
    else return null;
};

export const isPropertyOrPropertyExclusiveDataBindingMode = (virtualPanel: IVirtualPanelItem): boolean =>
    [DataBindingMode.PropertyExclusive, DataBindingMode.Property].includes(virtualPanel.virtualPanel.dataBindingMode);

export const isPropertyDataBindingMode = (virtualPanel: IVirtualPanelItem): boolean =>
    virtualPanel.virtualPanel.dataBindingMode === DataBindingMode.Property;

export const isPropertyExclusiveDataBindingMode = (virtualPanel: IVirtualPanelItem): boolean =>
    DataBindingMode.PropertyExclusive === virtualPanel.virtualPanel.dataBindingMode;

export const isOnRequestDataBindingMode = (virtualPanel: IVirtualPanelItem): boolean =>
    virtualPanel.virtualPanel.dataBindingMode === DataBindingMode.OnRequest;

export const isSingleDataBindingMode = (virtualPanel: IVirtualPanelItem): boolean =>
    DataBindingMode.Single === virtualPanel.virtualPanel.dataBindingMode;

export const setMenuItemVisibility = (menuItem: IMenuItem, value: boolean): boolean => {
    const v = value ?? !menuItem.hidden$.value;
    menuItem.hidden$.next(v);
    return v;
};
/*@TODO hideMenuItem showMenuItem???*/

export const updateVisibleMenuItems = (tabSelector: ITabSelector, inc: number = 1): number => {
    const v = tabSelector.visibleMenuItemsCount$.value + inc;
    tabSelector.visibleMenuItemsCount$.next(v);
    return v;
};

export const incrementVisibleMenuItems = (tabSelector: ITabSelector): number => updateVisibleMenuItems(tabSelector, 1);
export const decrementVisibleMenuItems = (tabSelector: ITabSelector): number => updateVisibleMenuItems(tabSelector, -1);

export const getEntityIndex = (entity: ICpEntity): number =>
    (entity.path?.full.filter((part) => part.isIndex()).pop()?.value as number) ?? -1;
